import React from 'react';
import {FormattedMessage} from 'react-intl';
import {useField, useFormikContext} from 'formik';
import {StyledFieldInput} from '../../../../_common/components/FieldInput';
import {OldInspectionFormChangeNameProvider} from '../../OldInspectionFormChangeNameContext';
import ModalHeader from '../../../../_common/components/ModalHeader';
import ModalContent from '../../../../_common/components/ModalContent';
import ModalButtonsContainer from '../../../../_common/components/ModalButtonsContainer';
import ButtonAction from '../../../../_common/components/ButtonAction';
import {buttonCancel, buttonSubmit, largeButtonsPadding} from '../../../../_common/styles/styles';

const Form = ({onClose}) => {
  const [field, meta] = useField('fileName');
  const {isValid, submitForm} = useFormikContext();

  const close = () => {
    if (onClose) {
      onClose();
    }
  };

  return (
    <>
      <ModalHeader
        header={<FormattedMessage id={'tab-order-documents-popup-edit-file-name-header'} defaultMessage={'Edit file name'}/>}
      />
      <ModalContent customClassnames={'bg-transparent'}>
        <StyledFieldInput
          {...field}
        />
        {meta.error && meta.touched && <div className="small text-danger">{meta.error}</div>}
      </ModalContent>
      <ModalButtonsContainer customClassnames={largeButtonsPadding}>
        <ButtonAction
          variant={'cancel'}
          onClick={close}
          label={'סגירה'}
          customClassnames={buttonCancel}
        />
        <ButtonAction
          onClick={submitForm}
          useIcon={'/media/common/Check-in-circle_white.svg'}
          label={'שליחה'}
          disabled={!isValid}
          customClassnames={buttonSubmit}
        />
      </ModalButtonsContainer>
    </>
  );
};

const FormChangeFileName = ({fileID, fileName, onClose}) => {
  return (
    <OldInspectionFormChangeNameProvider fileID={fileID} currentFileName={fileName} onSubmit={onClose}>
      <Form onClose={onClose}/>
    </OldInspectionFormChangeNameProvider>
  );
};

export default FormChangeFileName;